import DeepFocusLogo from "@/assets/icons/deep-focus-logo.svg";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

interface DeepFocusEntryButtonProps {
    disabled?: boolean;
    onClick: () => void;
    showNotInPlanTooltip?: boolean;
    sideListMode?: boolean;
}

const DeepFocusEntryButton = ({
    disabled,
    onClick,
    showNotInPlanTooltip,
    sideListMode,
}: DeepFocusEntryButtonProps) => {
    const { t } = useTranslation();

    const button = (
        <Button
            className={cn(
                "transition-all duration-300",
                sideListMode && "[&_div]:gap-0",
            )}
            disabled={disabled}
            onClick={onClick}
            size="lg"
            variant="deepFocusEntry"
        >
            <img alt="" className="size-6 shrink-0" src={DeepFocusLogo} />
            <span
                className={cn(
                    "overflow-hidden text-base font-semibold transition-all duration-300",
                    sideListMode ? "w-0" : "w-22",
                )}
            >
                {!sideListMode && t("deepFocus.title")}
            </span>
        </Button>
    );

    return (
        <span
            className={cn("inline-flex rounded-full", disabled && "opacity-50")}
        >
            {showNotInPlanTooltip ? (
                <Tooltip>
                    <TooltipTrigger asChild>{button}</TooltipTrigger>
                    <TooltipContent>
                        <p>{t("deepFocus.notInPlan")}</p>
                    </TooltipContent>
                </Tooltip>
            ) : (
                button
            )}
        </span>
    );
};

export default DeepFocusEntryButton;
